import Vue from 'vue'
import axios from 'axios'
import App from './App.vue'
import { router } from './_router'
import { store } from './_store'
import vuetify from './plugins/vuetify';
//@ts-ignore
import VueSignaturePad from 'vue-signature-pad';
//@ts-ignore
import JsonExcel from 'vue-json-excel'
import AssociataFilter from "./_filters/associataFilter";
import ArtigianaFilter from "./_filters/artigianaFilter";
import ArticolazioniFilter from "./_filters/articolazioniFilter";
import IndirizziStudioFilter from "./_filters/indirizziStudioFilter";
import RuoliFilter from "./_filters/ruoliFilter";
import ValutazioneFilter from "./_filters/valutazioneFilter"
//@ts-ignore
import BooleanFilter from "./_filters/booleanFilter"
import UppercaseFilter from "./_filters/uppercaseFilter"
import TipoAttivitaFilter from "./_filters/tipoAttivitaFilter"


Vue.config.productionTip = false

Vue.use(VueSignaturePad);
Vue.component('downloadExcel', JsonExcel)

Vue.filter('associataFilter', AssociataFilter)
Vue.filter('artigianaFilter', ArtigianaFilter)
Vue.filter('articolazioniFilter', ArticolazioniFilter)
Vue.filter('indirizziStudioFilter', IndirizziStudioFilter)
Vue.filter('ruoliFilter', RuoliFilter)
Vue.filter('valutazioneFilter', ValutazioneFilter)
Vue.filter('booleanFilter', BooleanFilter)
Vue.filter('uppercaseFilter', UppercaseFilter)
Vue.filter('tipoAttivitaFilter', TipoAttivitaFilter)

function extractBackendErrorMessage(payload: any): string | null {
  if (payload === null || payload === undefined) {
    return null;
  }

  if (typeof payload === 'string') {
    const text = payload.trim();
    if (!text || /^\d{3}$/.test(text) || /^Request failed with status code\s+\d{3}$/i.test(text)) {
      return null;
    }
    return text;
  }

  if (Array.isArray(payload)) {
    const values = payload
      .map((item) => extractBackendErrorMessage(item))
      .filter((item): item is string => !!item);
    return values.length > 0 ? values.join('\n') : null;
  }

  if (typeof payload === 'object') {
    const commonFields = [
      'message',
      'Message',
      'error',
      'error_description',
      'detail',
      'details',
      'title',
      'ExceptionMessage',
      'descrizione'
    ];

    for (const field of commonFields) {
      if (Object.prototype.hasOwnProperty.call(payload, field)) {
        const text = extractBackendErrorMessage(payload[field]);
        if (text) {
          return text;
        }
      }
    }

    if (Object.prototype.hasOwnProperty.call(payload, 'errors')) {
      const text = extractBackendErrorMessage(payload.errors);
      if (text) {
        return text;
      }
    }
  }

  return null;
}

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const data = error && error.response ? error.response.data : null;
    const message = extractBackendErrorMessage(data);
    if (message) {
      (globalThis as any).__valtisLastBackendError = {
        message,
        status: error && error.response ? error.response.status : null,
        at: Date.now()
      };
    }
    return Promise.reject(error);
  }
);

export const bus = new Vue();

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
